import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import { typeName } from '../../fieldOptions/sessionSaleTypes'

const columns = [
  { title: 'Title', prop: 'title' },
  { title: 'Advertised Start Date', prop: 'advertised_start_date', format: 'dateWithDay' },
  { title: 'Type', prop: 'type', format: typeName },
  { title: 'Published', prop: 'published_at', format: 'bool' },
  { title: 'Updated', prop: 'updated_at', format: 'dateWithDay' }
]

const filters = []

const defaults = {
  order: [{ column: 'advertised_start_date', direction: 'desc' }]
}

const SessionSales = (props) => (
  <List
    title='Session Sales'
    apiPath='admin/session_sales'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default SessionSales
